// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__13YQ2","requiredAsterisk":"Info_requiredAsterisk__xjy-0"};